/*!jslint this */
jQuery(function ($) {
  "use strict";

  const $window = $(window);
  const $document = $(document);

  let resizeRaf = null;

  /**
   * Set CSS app height variable
   */
  function setAppHeight() {
    document.documentElement.style.setProperty(
      '--app-height',
      window.innerHeight + 'px'
    );
  }

  /**
   * Optimized resize handler
   */
  function onResize() {
    if (resizeRaf) {
      cancelAnimationFrame(resizeRaf);
    }

    resizeRaf = requestAnimationFrame(setAppHeight);
  }

  // Initial set (delay allows mobile UI to settle)
  setTimeout(setAppHeight, 100);

  // Resize listener
  $window.on('resize', onResize);

  /**
   * Mobile navigation toggle with focus management
   */
  const mobileNav = document.getElementById("mobile-navigation");
  let lastFocusedElement = null;

  function getInertTargets() {
    return Array.prototype.slice.call(
      document.querySelectorAll(".skip-link, .site-header-in, #primary, #colophon")
    );
  }

  function getFocusableElements(container) {
    if (!container) {
      return [];
    }

    const selector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(selector));
  }

  function setBackgroundInert(isInert) {
    getInertTargets().forEach(function (el) {
      if (isInert) {
        el.setAttribute("inert", "");
        el.setAttribute("aria-hidden", "true");
      } else {
        el.removeAttribute("inert");
        el.removeAttribute("aria-hidden");
      }
    });
  }

  function trapMobileNavFocus(e, toggleEl) {
    if (e.key !== "Tab") {
      return;
    }

    const focusable = [toggleEl].concat(getFocusableElements(mobileNav));

    if (!focusable.length) {
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onMobileNavKeydown(e, toggleEl) {
    if (e.key === "Escape" || e.key === "Esc") {
      closeMobileNav($(toggleEl));
      return;
    }

    trapMobileNavFocus(e, toggleEl);
  }

  function openMobileNav($toggle) {
    lastFocusedElement = $toggle[0];

    $("html").addClass("nav-open");
    $toggle.attr("aria-expanded", "true");
    setBackgroundInert(true);

    const focusable = getFocusableElements(mobileNav);
    if (focusable.length) {
      focusable[0].focus();
    }

    $document.on("keydown.mobileNav", function (e) {
      onMobileNavKeydown(e, $toggle[0]);
    });
  }

  function closeMobileNav($toggle) {
    $("html").removeClass("nav-open");
    $toggle.attr("aria-expanded", "false");
    setBackgroundInert(false);
    $document.off("keydown.mobileNav");

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  $(document).on("click", ".nav-toggle", function (e) {
    const $toggle = $(this);
    const isOpen = $("html").hasClass("nav-open");

    if (isOpen) {
      closeMobileNav($toggle);
    } else {
      openMobileNav($toggle);
    }
  });

  /**
   * WOW.js init (guarded)
   */
  if (typeof WOW === 'function') {
    new WOW().init();
  }

});

/**
 * Blog page pagination with AJAX (page-blog.php).
 *
 * Clicking a page link asks admin-ajax.php (action "accessmate_blog_page", see
 * inc/custom-functions.php) for that page's results and replaces only
 * #blog-listing. Progressive enhancement: the links still work normally without
 * JavaScript, if the request fails, or when opened in a new tab (Ctrl/Cmd/Shift
 * click, middle click).
 *
 * Accessibility:
 * - aria-busy on the listing while the next page loads (no fade: the swap is
 *   instant once the page and its images are ready).
 * - After the swap, focus moves to "Showing 7–12 of 24 articles", so keyboard
 *   users continue from the top of the new list and screen readers read it.
 * - The address bar and page title update, so Back/Forward, bookmarks and
 *   sharing work; Back/Forward load just the listing too.
 * - Smooth scrolling only when the visitor hasn't asked for reduced motion.
 */
jQuery(function ($) {
  "use strict";

  const $listing = $("#blog-listing");

  if (!$listing.length || !window.history.pushState) {
    return;
  }

  const ajaxUrl = $listing.data("ajax-url");
  const pageId = $listing.data("page-id");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  // One request per page number, kept for the visit: pages already seen (and
  // Back/Forward) show instantly, and a page is fetched once even if its link is
  // hovered, focused and clicked.
  const cache = {};
  let latestUrl = "";

  // Page number from a link: /blog/page/3/ or ?paged=3. No number = page 1.
  function pageFromUrl(url) {
    const match = url.match(/\/page\/(\d+)\/?/) || url.match(/[?&]paged=(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  // Download the images of a page before it is shown, so the new cards appear
  // complete in one go instead of the images popping in afterwards. Gives up
  // after 1 second so a slow image never holds the page back.
  function preloadImages(html) {
    const ready = $.Deferred();
    const images = $($.parseHTML(html)).find("img").get();
    let pending = images.length;

    if (!pending) {
      return ready.resolve().promise();
    }

    const timer = setTimeout(ready.resolve, 1000);

    images.forEach(function (source) {
      const img = new Image();

      img.onload = img.onerror = function () {
        pending -= 1;
        if (!pending) {
          clearTimeout(timer);
          ready.resolve();
        }
      };

      if (source.getAttribute("sizes")) {
        img.sizes = source.getAttribute("sizes");
      }
      if (source.getAttribute("srcset")) {
        img.srcset = source.getAttribute("srcset");
      }
      img.src = source.getAttribute("src");
    });

    return ready.promise();
  }

  // Resolves with the page data once its HTML and images are ready.
  function fetchPage(url) {
    const paged = pageFromUrl(url);

    if (!cache[paged]) {
      cache[paged] = $.ajax({
        url: ajaxUrl,
        method: "GET",
        dataType: "json",
        data: {
          action: "accessmate_blog_page",
          page_id: pageId,
          paged: paged
        }
      })
        .then(function (response) {
          if (!response || !response.success) {
            return $.Deferred().reject().promise();
          }
          return preloadImages(response.data.html).then(function () {
            return response.data;
          });
        })
        .fail(function () {
          delete cache[paged]; // Try again next time.
        });
    }

    return cache[paged];
  }

  function showPage(url, data, addToHistory) {
    $listing.html(data.html);

    if (data.title) {
      document.title = data.title;
    }

    if (addToHistory) {
      window.history.pushState({ blogListing: true }, "", url);
    }

    $listing[0].scrollIntoView({
      behavior: reduceMotion.matches ? "auto" : "smooth",
      block: "start"
    });

    const count = $listing.find(".blog-listing__count")[0];

    if (count) {
      count.focus({ preventScroll: true });
    }
  }

  function loadPage(url, addToHistory) {
    latestUrl = url;
    $listing.attr("aria-busy", "true");

    fetchPage(url)
      .done(function (data) {
        // A newer click wins.
        if (url === latestUrl) {
          showPage(url, data, addToHistory);
        }
      })
      .fail(function () {
        // Fall back to a normal page load.
        if (url === latestUrl) {
          window.location.href = url;
        }
      })
      .always(function () {
        if (url === latestUrl) {
          $listing.removeAttr("aria-busy");
        }
      });
  }

  function isPlainClick(event, link) {
    return event.which === 1 &&
      !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
      link.origin === window.location.origin;
  }

  // Start loading as soon as a link is pointed at, focused or touched, so the
  // page is usually ready by the time it is clicked.
  $listing.on("mouseenter focusin touchstart", ".blog-pagination a", function () {
    if (this.origin === window.location.origin) {
      fetchPage(this.href);
    }
  });

  $listing.on("click", ".blog-pagination a", function (event) {
    if (!isPlainClick(event, this)) {
      return;
    }

    event.preventDefault();
    loadPage(this.href, true);
  });

  // Mark the first page so Back returns to it without a full reload.
  window.history.replaceState({ blogListing: true }, "", window.location.href);

  $(window).on("popstate", function (event) {
    const state = event.originalEvent.state;

    if (state && state.blogListing) {
      loadPage(window.location.href, false);
    }
  });
});
